/* Let the native Judge.me sorter use one list across review languages. */
(() => {
  const prepare = () => {
    if (!window.jdgmSettings) return;
    window.jdgmSettings.widget_multilingual_sorting_enabled = false;
    document.querySelectorAll('.jdgm-review-widget .jdgm-rev-widg__body').forEach(body => {
      const primary = body.querySelector('.jdgm-rev-widg__primary-content');
      if (primary) body.innerHTML = primary.innerHTML;
    });
    const refresh = () => {
      document.querySelectorAll('.jdgm-review-widget').forEach(widget => {
        const select = widget.querySelector('.jdgm-sort-dropdown');
        if (!select || widget.dataset.mvSortReady || !window.jdgm?._setupLoadReviewsEventsFor) return;
        widget.dataset.mvSortReady = 'true';
        setTimeout(() => {
          select.value = 'most-recent';
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }, 0);
      });
    };
    const observer = new MutationObserver(refresh);
    observer.observe(document.body, { childList: true, subtree: true });
    refresh();
  };
  document.addEventListener('DOMContentLoaded', prepare, { once: true });
})();
